<template>
  <div class="pos-cate">
    <el-input
      v-model="keyword"
      size="mini"
      :placeholder="placeholder"
      @input="searchCate"
      @keyup.native.enter="handleClick"
    >
      <!-- <i class="el-icon-question" slot="suffix" @click="showSelectFunction" /> -->
      <div
        slot="suffix"
        style="cursor:pointer;padding:0;display:flex;align-items:center;justify-content:center;height:28px"
        @click="showSelectFunction"
      >
        <i slot="suffix" class="el-icon-question" style="margin-right:5px" />职能模块库
      </div>
    </el-input>
    <div v-if="keyword" class="pos-cate-drop el-select-dropdown el-popper" x-placement="bottom-start">
      <div x-arrow="" class="popper__arrow" style="left: 35px;"></div>
      <div class="pos-cate-drop-item">
        <div>您要搜索的是:<span>（请勾选要搜索的内容）</span></div>
      </div>
      <div style="max-height:calc(100vh - 260px);overflow:auto;">
        <div v-if="!ignore.includes('关键词')" class="pos-cate-drop-item">
          <div class="drop-label">关键词:</div>
          <div class="drop-content">
            <div class="drop-content-item">
              <span
                class="drop-content-highlight"
                style="font-size:14px;font-weight:bold;cursor: pointer;"
                @click="handleClick"
              >
                {{ keyword }}
              </span>
            </div>
          </div>
        </div>
        <div v-if="!ignore.includes('职位名称')" class="pos-cate-drop-item">
          <div class="drop-label">职位名称:</div>
          <div class="drop-content">
            <el-checkbox-group v-model="dropData.职位名称">
              <div class="drop-content-item">
                <el-checkbox :label="keyword">
                  <span class="drop-content-highlight">{{ keyword }}</span>
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </div>
        <div v-if="!ignore.includes('部门')" class="pos-cate-drop-item">
          <div class="drop-label">部门:</div>
          <div class="drop-content">
            <el-checkbox-group v-model="dropData.部门">
              <div class="drop-content-item">
                <el-checkbox :label="keyword">
                  <span class="drop-content-highlight">{{ keyword }}</span>
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </div>
        <div v-if="!ignore.includes('职能模块')" class="pos-cate-drop-item">
          <div class="drop-label">职能模块:</div>
          <div class="drop-content">
            <div v-if="opts.职能模块 && opts.职能模块.length > 0">
              <el-checkbox-group v-model="dropData.职能模块">
                <div v-for="(v, k) in opts.职能模块" :key="k" class="drop-content-item">
                  <el-checkbox :label="v"> <span v-html="formatHighlight(v)"> </span> </el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
            <span v-else>无</span>
          </div>
        </div>
        <div v-if="!ignore.includes('细分职能')" class="pos-cate-drop-item">
          <div class="drop-label">细分职能:</div>
          <div class="drop-content">
            <div v-if="opts.细分职能 && opts.细分职能.length > 0">
              <el-checkbox-group v-model="dropData.细分职能">
                <div v-for="(v, k) in opts.细分职能" :key="k" class="drop-content-item">
                  <el-checkbox :label="v"> <span v-html="formatHighlight(v)"> </span> </el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
            <span v-else>无</span>
          </div>
        </div>
        <div v-if="!ignore.includes('擅长方向')" class="pos-cate-drop-item">
          <div class="drop-label">擅长方向:</div>
          <div class="drop-content">
            <div v-if="opts.擅长方向 && opts.擅长方向.length > 0">
              <el-checkbox-group v-model="dropData.擅长方向">
                <div v-for="(v, k) in opts.擅长方向" :key="k" class="drop-content-item">
                  <el-checkbox :label="v"> <span v-html="formatHighlight(v)"> </span> </el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
            <span v-else>无</span>
          </div>
        </div>
        <div v-if="!ignore.includes('个性标签')" class="pos-cate-drop-item">
          <div class="drop-label">个性标签:</div>
          <div class="drop-content">
            <el-checkbox-group v-model="dropData.个性标签">
              <div class="drop-content-item">
                <el-checkbox :label="keyword">
                  <span class="drop-content-highlight">{{ keyword }}</span>
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <div style="padding-top: 5px;text-align:right">
        <div class="radish-btn radish-btn-primary" @click="handleComfirm">确定</div>
      </div>
    </div>
    <SelectFunction
      ref="SelectFunction"
      :modal="false"
      :show-category-detail="showCategoryDetail"
      @confirm="addFunction"
    ></SelectFunction>
  </div>
</template>
<script>
import SelectFunction from '../../../company/src/hunting/selectFunction'

export default {
  components: { SelectFunction },
  props: {
    ignore: { type: Array, default: () => [] },
    showCategoryDetail: { type: Boolean, default: true },
  },
  data() {
    return {
      keyword: '',
      dropData: {
        职位名称: [],
        部门: [],
        职能模块: [],
        细分职能: [],
        擅长方向: [],
        个性标签: [],
      },
      opts: {
        职能模块: [],
        细分职能: [],
        擅长方向: [],
      },
      placeholder: '',
    }
  },
  mounted() {
    const fields = ['职位名称', '部门', '职能模块', '细分职能', '擅长方向']
    const str = fields.filter(val => !this.ignore.includes(val)).join(' / ')
    this.placeholder = `请输入${str}等关键词`
  },
  methods: {
    async searchCate(keyword) {
      if (!this.keyword) return
      if (!app.categories) {
        await app.getCats()
      }
      const cateData = app.categories
      const cate = []
      const xi = []
      const shan = []
      cateData.forEach(c => {
        if (c.名称.match(new RegExp(this.keyword, 'i'))) {
          cate.push(c.名称)
        }
        if (c.二级职能 && c.二级职能.length > 0) {
          c.二级职能.forEach(er => {
            if (er.match(new RegExp(this.keyword, 'i'))) {
              xi.push(`${c.名称}@@${er}`)
            }
          })
        }
        if (c.擅长方向 && c.擅长方向.length > 0) {
          c.擅长方向.forEach(s => {
            if (s.match(new RegExp(this.keyword, 'i'))) {
              shan.push(`${c.名称}@@${s}`)
            }
          })
        }
      })
      this.opts = {
        职能模块: cate,
        细分职能: xi,
        擅长方向: shan,
      }
    },
    handleComfirm() {
      const arr = []
      Object.keys(this.dropData).forEach(k => {
        const v = this.dropData[k]
        if (v.length > 0) {
          v.forEach(vv => {
            arr.push({ name: k, val: vv, label: `${k}:${vv.replace(/@@/g, '/')}` })
          })
        }
      })
      if (arr.length > 0) {
        this.$emit('confirm', arr)
      } else if (!this.ignore.includes('关键词')) {
        this.$emit('confirm', [{ name: '关键词', val: this.keyword, label: `关键词:${this.keyword}` }])
      }
      console.log(arr)
      this.keyword = ''
      this.dropData = {
        职位名称: [],
        部门: [],
        职能模块: [],
        细分职能: [],
        擅长方向: [],
        个性标签: [],
      }
    },
    handleClick() {
      if (!this.ignore.includes('关键词')) {
        this.$emit('confirm', [{ name: '关键词', val: this.keyword, label: `关键词:${this.keyword}` }])
        this.keyword = ''
      }
    },
    formatHighlight(str) {
      return str.replace('@@', '/').replace(this.keyword, `<span class="drop-content-highlight">${this.keyword}</span>`)
    },
    showSelectFunction() {
      this.$refs.SelectFunction.open()
    },
    addFunction(func) {
      if (!func || func.length == 0) return
      const arr = []
      func.map(f => {
        if ((!f.细分职能 || f.细分职能.length === 0) && (!f.擅长方向 || f.擅长方向.length === 0)) {
          arr.push({ name: '职能模块', val: f.名称, label: `职能模块:${f.名称}` })
        }
        f.细分职能 &&
          f.细分职能.length > 0 &&
          f.细分职能.map(xi => {
            arr.push({ name: '细分职能', val: `${f.名称}@@${xi}`, label: `细分职能:${f.名称}/${xi}` })
          })
        f.擅长方向 &&
          f.擅长方向.length > 0 &&
          f.擅长方向.map(s => {
            arr.push({ name: '擅长方向', val: `${f.名称}@@${s}`, label: `擅长方向:${f.名称}/${s}` })
          })
      })
      this.$emit('confirm', arr)
    },
  },
}
</script>
<style>
.pos-cate {
  position: relative;
  width: 100%;
}
.pos-cate-drop {
  padding: 10px;
}
.pos-cate-drop-item {
  display: flex;
  padding: 5px 0;
  border-bottom: 1px solid #eee;
  color: #606266;
}
.pos-cate-drop-item .drop-label {
  min-width: 60px;
}
.pos-cate-drop-item .drop-content {
  padding-left: 5px;
}
.drop-content-highlight {
  color: #409eff;
}
</style>
